import axios from "axios";
import { LoginRequest, LoginResponse } from "../../types/auth";
import { newAbortSignal } from "../../utils";

const BASE_URL = `${process.env.REACT_APP_BACKEND_URL}/auth/signin`;

export const login = async ({
  email,
  password,
}: LoginRequest): Promise<LoginResponse> => {
  return await axios
    .post<LoginResponse>(
      BASE_URL,
      {
        email: email,
        password: password,
      },
      {
        headers: {
          "content-type": "application/json",
        },
        timeout: Number.parseInt(`${process.env.REACT_APP_AXIOS_TIME_OUT}`),
        signal:
          AbortSignal.timeout === undefined
            ? newAbortSignal(Number(process.env.REACT_APP_AXIOS_TIME_OUT))
            : AbortSignal.timeout(Number(process.env.REACT_APP_AXIOS_TIME_OUT)),
      }
    )
    .then((response) => response.data);
};
